import React, { ReactNode, useEffect } from 'react';
import { FronteggProvider } from '@frontegg/react';
import { useSearchParams } from 'react-router-dom';
import config from 'config';
import { declinedFronteggLogin, forgetFronteggUser } from 'utils/frontegg-user';
import { AppName, AppNameValue, getAppName } from 'utils/search-params';

interface FronteggProviderWrapperProps {
  children: ReactNode;
}

const fronteggAppIdByApp: Record<AppNameValue, string | undefined> = {
  [AppName.PLAYGROUND]: config.frontegg?.playgroundAppId,
  [AppName.ABU_TAGGING]: config.frontegg?.abuTaggingAppId
};

export function FronteggProviderWrapper({ children }: FronteggProviderWrapperProps): JSX.Element {
  const [searchParams] = useSearchParams();
  const appName = getAppName(searchParams);

  const appId = appName ? fronteggAppIdByApp[appName] : undefined;
  const shouldForceOldMongoLogin = declinedFronteggLogin(searchParams);

  useEffect(() => {
    if (shouldForceOldMongoLogin) {
      forgetFronteggUser();
    }
  }, [shouldForceOldMongoLogin]);

  const contextOptions = {
    baseUrl: config.frontegg?.baseUrl,
    clientId: config.frontegg?.clientId,
    ...(appId && { appId })
  };

  const shouldLoadUserOnFirstLoad = Boolean(appId);

  const authOptions = {
    keepSessionAlive: true,
    hostedLoginOptions: {
      loadUserOnFirstLoad: shouldLoadUserOnFirstLoad
    }
  };

  return (
    <FronteggProvider contextOptions={contextOptions} authOptions={authOptions} hostedLoginBox>
      {children}
    </FronteggProvider>
  );
}
